import React from 'react';

import { Formik, FormikValues } from 'formik';

import ClientForm from '../ClientForm/ClientForm';
import { BLANK_FORM_CLIENT } from '../blankForms';

interface IOwnProps {
    initialValues: FormikValues | null;
}
const ClientPreviewForm = ({ initialValues }: IOwnProps) => {
    const handleValues = () => {};

    return (
        <Formik
            enableReinitialize={true}
            initialValues={initialValues || BLANK_FORM_CLIENT}
            onSubmit={handleValues}
            validateOnBlur={false}
            validateOnChange={false}
            validate={() => ({})}
        >
            {({ errors, values, setFieldValue }) => (
                <ClientForm
                    values={values}
                    errors={errors}
                    readOnly
                    setFieldValue={setFieldValue}
                />
            )}
        </Formik>
    );
};

export default ClientPreviewForm;
